export const SECTION_NAME = 'Project Codes';

export const ADD_PROJECT_CODE_CONTROL = 'add-project-code-control';
export const EXISTING_PROJECT_CODES_ERROR = 'existing-project-codes-error';
export const EXISTING_PROJECT_CODES_MESSAGE = 'Project code already exists';

export type ProjectCodesFilters = {
    name?: string,
    activeOnly?: boolean,
};
